import { useRef, useEffect, useState } from 'react';
import { getActiveState } from '../helpers/titreHelper';
import { useGetParams } from './useGetParams';
import { useInterval } from './useInterval';

export const useVote = () => {
  const { user } = useGetParams();

  const currentStateRef = useRef(null);
  const isVisibleRef = useRef(null);
  const [voteState, setVoteState] = useState(null);

  const [variants, setVariants] = useState([]);

  const messagesRef = useRef([]);

  const protocol = window?.location.protocol || 'https:';

  const getVoteInfo = async () => {
    try {
      if (!user) {
        return;
      }

      const response = await fetch(
        `${protocol}//stream.iactive.pro/scr/getPollInfo.php?user=${user}`,
        { cache: 'no-store' },
      );
      const data = await response.json();
      if (!data) return;
      let { visibility, activity } = data;
      // Определяем видимость титра
      const isVisible = Boolean(Number(visibility));
      // const isActivity = Boolean(Number(activity));
      if (!isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = false;
      } else if (isVisible && isVisible !== isVisibleRef.current) {
        isVisibleRef.current = true;
      }
      // Определяем состояние (S1, S2 ...)
      if (
        data?.state &&
        getActiveState(data?.state) !== currentStateRef.current
      ) {
        currentStateRef.current = getActiveState(data?.state);
      }

      const equal = require('fast-deep-equal');
      if (!equal(voteState, data)) {
        setVoteState(data);
      }

      // if (!equal(variants, data?.vars)) {
      setVariants(data?.vars);
      // }

      data.vars.forEach((variant) => {
        const curVariant = variants?.find((v) => v.id === variant.id);

        if (curVariant) {
          const delta = Number(variant.count) - Number(curVariant.count);

          for (let index = 0; index < delta; index++) {
            messagesRef.current = [
              ...messagesRef.current,
              {
                id: curVariant.id + '-' + variant.count + '-' + index,
                message: {
                  image: curVariant.varImgUrl,
                  comment: curVariant.comment,
                },
              },
            ];
          }
        }
      });

      // console.log(
      //   'messagesRef.current',
      //   messagesRef.current.map((m) => m.message.comment),
      //   messagesRef.current,
      // );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getVoteInfo();
  }, []);

  useInterval(() => {
    getVoteInfo();
  }, 1000);

  return {
    currentState: currentStateRef.current,
    isVisible: isVisibleRef.current,
    voteState,
    messages: messagesRef.current,
  };
};
